
import Vue from 'vue';
import { Accordion, Button } from '@descomplica/vue-components';
import { TabType } from './types';

export default Vue.extend({
  components: {
    TextButton: Button,
    Accordion,
  },
  computed: {
    orientationsItems() {
      const itemsLabel = [
        'summary',
        'introduction',
        'theoreticalReference',
        'methodology',
        'dataAnalysisAndDiscussion',
        'conclusion',
      ];

      return itemsLabel.map((label) => ({
        title: this.$t(`yourAssessments.tcc.tabs.orientationsItems.${label}.title`),
        contents: this.$t(`yourAssessments.tcc.tabs.orientationsItems.${label}.contents`),
      }));
    },
  },
  methods: {
    goToNextTab() {
      this.$emit('selectTab', TabType.evaluationCriteria);
    },
  },
});
